<template>
	<div class="rightBlock" ref='rightBlock' :class='rightData.tagName || rightData.systemPage? "":"hideright"'>
		<div class="title"  v-if='rightData' >
			<div @click='rightData.navOn=index'  class="li" :class='rightData.nav.length>1 &&rightData.navOn ==index? "on":""' v-for='(item,index) in rightData.nav' :key='index' >
				{{item}}
			</div>
			<div class="li" v-if='rightData.page=="goodsClassify"'>分类设置</div>
		</div>
		<div class="content"  v-if='rightData'>
			<div class="propbox" v-if='rightData.navOn==0'>
				<el-form label-width="82px">
					<div v-if='rightData.tagName=="导航栏"'>
						<el-form-item label='背景色'>
							<el-radio v-model='rightData.bgColor' label='#ffffff'>白色</el-radio>
							<el-radio v-model='rightData.bgColor' label='useSys'>使用全局颜色</el-radio>
							<el-radio v-model='rightData.bgColor' label="useUser">自定义颜色</el-radio>
						</el-form-item>
						<el-form-item label='自定义背景' v-if='rightData.bgColor=="useUser"'>
							<el-color-picker v-model="rightData.userBg" :predefine='ajaxData.colorful'></el-color-picker>
						</el-form-item>
						<el-form-item label='文本颜色'>
							<el-radio v-model='rightData.frontColor' label='#ffffff'>白色</el-radio>
							<el-radio v-model='rightData.frontColor' label='#000000'>黑色</el-radio>
						</el-form-item>
					</div>
					<div v-if='rightData.tagName=="服务详情"'>
						<el-form-item label='分享按钮'>
							<el-switch size='medium'  v-model='rightData.showShare'/>
						</el-form-item>
						<el-form-item label='电话按钮'>
							<el-switch size='medium'  v-model='rightData.showPhone'/>
						</el-form-item>
						<el-form-item label='按钮文本'>
							<el-input size='medium'  v-model='rightData.btn' style='width:250px;margin-right: 10px'/>
						</el-form-item>
						<el-form-item label='按钮跳转'>
							<el-radio v-model='appConfig.severConfig.btnAction' label='确认订单'></el-radio>
							<el-radio v-model='appConfig.severConfig.btnAction' label='拨打电话'></el-radio>
						</el-form-item>
						<el-form-item label='支付设置' v-if='appConfig.severConfig.btnAction =="确认订单"'>
							<el-radio  v-model='appConfig.severConfig.payType' label='微信支付'></el-radio>
							<el-radio  v-model='appConfig.severConfig.payType' label='到店支付'></el-radio>
						</el-form-item>
					</div>
					<div v-if='rightData.tagName=="名片详情"'>
						<el-form-item label='分享按钮'>
							<el-switch size='medium'  v-model='rightData.showShare'/>
						</el-form-item>
					</div>
					<div v-if='rightData.tagName=="文本"'>
						<el-form-item label='字号' >
							<el-select v-model="rightData.fontsize" placeholder="请选择">
								<el-option v-for="item in [12,13,14,15,16,18,20,24,30,32,36]" :key="item" :label="item" :value="item">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label='字体颜色'>
							<el-color-picker v-model="rightData.color" show-alpha :predefine='ajaxData.colorful'></el-color-picker>
						</el-form-item>
						<el-form-item label='字体样式'>
							<div class="fonstyle">
								<div class='icon' :class='rightData.b == "bold" ? "on":""'  @click='rightData.b=="bold"? rightData.b= "normal":rightData.b= "bold"'>
									<svg-icon class='ico' icon-class='b'/>
								</div>
								<div class='icon' :class='rightData.i == "italic" ? "on":""'  @click='rightData.i=="italic"? rightData.i= "normal":rightData.i= "italic"'>
									<svg-icon class='ico' icon-class='i'/>
								</div>
								<div class='icon' :class='rightData.align == "left" ? "on":""'  @click='rightData.align=="left"? rightData.align= "left":rightData.align= "left"'>
									<svg-icon class='ico' icon-class='align-left'/>
								</div>
								<div class='icon' :class='rightData.align == "center" ? "on":""'  @click='rightData.align=="center"? rightData.align= "left":rightData.align= "center"'>
									<svg-icon class='ico' icon-class='align-middle'/>
								</div>
								<div class='icon' :class='rightData.align == "right" ? "on":""'  @click='rightData.align=="right"? rightData.align= "left":rightData.align= "right"'>
									<svg-icon class='ico' icon-class='align-right'/>
								</div>
							</div>
						</el-form-item>
						<el-form-item label='z-index' >
							<el-input v-model.number='rightData.zIndex' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='宽高(px)' >
							<el-input v-model.number='rightData.width' size='medium' style='width:100px'/>
							<el-input  v-model.number='rightData.height' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='上边距(px)' >
							<el-input v-model.number='rightData.top' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='左边距(px)' >
							<el-input v-model.number='rightData.left' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='链接'>
							<el-input size='medium'  v-model='rightData.url' disabled style='width:250px;margin-right: 10px'/>
							<el-button size='medium'  @click='setUrl(rightData)'>设置链接</el-button>
						</el-form-item>
					</div>
					<div  v-if='rightData.tagName=="图片"'>
						<el-form-item label='图片' >
							<el-button @click='selectFreeImg' size='medium'>修改图片</el-button>
							<div class="rimg">
								<img :src="rightData.src" alt="">
							</div>
						</el-form-item>
						<el-form-item label='z-index' >
							<el-input v-model.number='rightData.zIndex' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='宽高(px)' >
							<el-input v-model.number='rightData.width' size='medium' style='width:100px'/>
							<el-input  v-model.number='rightData.height' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='上边距(px)' >
							<el-input v-model.number='rightData.top' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='左边距(px)' >
							<el-input v-model.number='rightData.left' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='链接'>
							<el-input size='medium'  v-model='rightData.url' disabled style='width:250px;margin-right: 10px'/>
							<el-button size='medium'  @click='setUrl(rightData)'>设置链接</el-button>
						</el-form-item>
					</div>
					<div  v-if='rightData.tagName=="按钮"'>
						<el-form-item label='按钮内容' >
							<el-input v-model='rightData.label' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='z-index' >
							<el-input v-model.number='rightData.zIndex' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='宽高(px)' >
							<el-input v-model.number='rightData.width' size='medium' style='width:100px'/>
							<el-input  v-model.number='rightData.height' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='上边距(px)' >
							<el-input v-model.number='rightData.top' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='左边距(px)' >
							<el-input v-model.number='rightData.left' size='medium' style='width:100px'/>
						</el-form-item>
						<el-form-item label='按钮颜色'>
							<el-color-picker v-model="rightData.color"  show-alpha size="small"  :predefine='ajaxData.colorful'></el-color-picker>
						</el-form-item>
						<el-form-item label='背景色' >
							<el-radio v-model='rightData.useStyle' :label='true'>使用全局颜色</el-radio>
							<el-radio v-model='rightData.useStyle' :label='false'>自定义颜色</el-radio>
							<br/>
							<el-color-picker v-if='!rightData.useStyle' show-alpha v-model="rightData.bgcolor" size="small"  :predefine='ajaxData.colorful'></el-color-picker>
						</el-form-item>


						<el-form-item label='链接'>
							<el-input size='medium' v-model='rightData.url' disabled style='width:250px;margin-right: 10px'/>
							<el-button size='medium' @click='setUrl(rightData)'>设置链接</el-button>
						</el-form-item>
					</div>
					<div  v-if='rightData.tagName=="input" || rightData.tagName=="upload"'>
						<el-form-item label='标题' >
							<el-input size='medium' v-model='rightData.label' style='width:160px;margin-right: 10px'/>
							<el-checkbox v-model='rightData.showLabel'>显示标题</el-checkbox>
						</el-form-item>
						<el-form-item label='提示文本' >
							<el-input size='medium'  v-model='rightData.placeholder' style='width:280px;margin-right: 10px'/>
						</el-form-item>
					</div>
					<div  v-if='rightData.tagName=="textarea"'>
						<el-form-item label='标题' >
							<el-input size='medium' v-model='rightData.label' style='width:160px;margin-right: 10px'/>
							<el-checkbox v-model='rightData.showLabel'>显示标题</el-checkbox>
						</el-form-item>
						<el-form-item label='提示文本' >
							<el-input size='medium'  v-model='rightData.placeholder' style='width:280px;margin-right: 10px'/>
						</el-form-item>
					</div>
					<div v-if='rightData.tagName=="datebox"'>
						<el-form-item label='标题' >
							<el-input size='medium' v-model='rightData.label' style='width:160px;margin-right: 10px'/>
							<el-checkbox v-model='rightData.showLabel'>显示标题</el-checkbox>
						</el-form-item>
						<el-form-item label='提示文本' >
							<el-input size='medium'  v-model='rightData.placeholder' style='width:280px;margin-right: 10px'/>
						</el-form-item>
					</div>
					<div v-if='rightData.tagName=="radio"'>
						<el-form-item label='标题' >
							<el-input size='medium' v-model='rightData.label' style='width:160px;margin-right: 10px'/>
							<el-checkbox v-model='rightData.showLabel'>显示标题</el-checkbox>
						</el-form-item>
						<el-form-item label='选项' >
							<el-tag  v-for="(tag,tagi) in rightData.section" :key='tagi' closable :disable-transitions="false" @close="delTag(rightData.section,tagi)" style='margin-right: 10px'> {{tag.value}}</el-tag>
							<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" size="small" @keyup.enter.native="confirmTag" @blur="confirmTag"  style='width: 80px;'>
							</el-input>
							<el-button v-else style='width: 80px;' class="button-new-tag" size="small" @click="showInput">添加</el-button>
						</el-form-item>
					</div>
					<div v-if='rightData.tagName=="checkbox"'>
						<el-form-item label='标题' >
							<el-input size='medium' v-model='rightData.label' style='width:160px;margin-right: 10px'/>
							<el-checkbox v-model='rightData.showLabel'>显示标题</el-checkbox>
						</el-form-item>
						<el-form-item label='选项' >
							<el-tag  v-for="(tag,tagi) in rightData.section" :key='tagi' closable :disable-transitions="false" @close="delTag(rightData.section,tagi)" style='margin-right: 10px'> {{tag.value}}</el-tag>
							<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" size="small" @keyup.enter.native="confirmTag" @blur="confirmTag"  style='width: 80px;'>
							</el-input>
							<el-button v-else style='width: 80px;' class="button-new-tag" size="small" @click="showInput">添加</el-button>
						</el-form-item>
					</div>


					<div v-if="rightData.tagName=='图标'" class="navicos">
						<el-form-item label='标题'>
							<el-input size='medium' v-model='rightData.label' style='width:220px;margin-right: 10px'/>
						</el-form-item>
						<el-form-item label='副标题'>
							<el-input size='medium' v-model='rightData.minTitle' style='width:220px;margin-right: 10px'/>
							<el-tooltip class="item" effect="dark" content="部分模块样式不显示副标题" placement="top">
								<svg-icon style='width: 20px;height: 20px;color:#999' icon-class='question'/>
							</el-tooltip>
						</el-form-item>
						<el-form-item label='标题样式'>
							<div class="style">
								<el-select v-model="rightData.fontsize" size='small' style='width: 100px' placeholder="请选择">
									<el-option v-for="item in [12,13,14,15,16,18,20,24,30,32,36]" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
								<el-color-picker v-model="rightData.color" show-alpha size="small" style='margin-left: 20px'  :predefine='ajaxData.colorful'></el-color-picker>
								<div class="fonstyle"  style='margin-left: 20px'>
									<div class='icon' :class='rightData.b == "bold" ? "on":""'  @click='rightData.b=="bold"? rightData.b= "normal":rightData.b= "bold"'>
										<svg-icon class='ico' icon-class='b'/>
									</div>
								</div>
							</div>
						</el-form-item>
						<el-form-item label='副标题样式'>
							<div class="style">
								<el-select v-model="rightData.minTitleFontsize" size='small' style='width: 100px' placeholder="请选择">
									<el-option v-for="item in [12,13,14,15,16,18,20,24,30,32,36]" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
								<el-color-picker v-model="rightData.minTitleColor" size="small" show-alpha style='margin-left: 20px'  :predefine='ajaxData.colorful' ></el-color-picker>
								<div class="fonstyle"  style='margin-left: 20px'>
									<div class='icon' :class='rightData.minTitleB == "bold" ? "on":""'  @click='rightData.minTitleB=="bold"? rightData.minTitleB= "normal":rightData.minTitleB= "bold"'>
										<svg-icon class='ico' icon-class='b'/>
									</div>
								</div>
							</div>
						</el-form-item>
						<el-form-item label='图标'>
							<template slot-scope="scope">
								<div class="tabbarico" @click='selectIco(rightData.icon)' style="height: 40px;width: 40px;">
									<svg-icon class='icos' v-if='rightData.icon.type=="图标"' :icon-class='rightData.icon.src'/>
									<img class='icos' v-else :src='rightData.icon.src'/>
								</div>
							</template>
						</el-form-item>
						<el-form-item label='图标颜色'>
							<el-color-picker v-if='rightData.icon.type=="图标"' v-model="rightData.icon.color" show-alpha></el-color-picker>
							<el-tooltip v-else class="item" effect="dark" content="仅对图标有效" placement="top">
								<svg-icon style='width: 20px;height: 20px;color:#999' icon-class='question'/>
							</el-tooltip>
						</el-form-item>
						<el-form-item label='背景'>
							<el-color-picker v-model="rightData.bgcolor"  :predefine='ajaxData.colorful' show-alpha size="small"></el-color-picker>
						</el-form-item>

						<el-form-item label='链接' >
							<el-input size='medium' v-model='rightData.url' disabled style='width:250px;margin-right: 10px'/>
							<el-button size='medium' @click='setUrl(rightData)'>设置链接</el-button>
						</el-form-item>
					</div>

					<el-form-item label='模块名称' v-if='rightData.title'>
						<el-input size='medium' v-model='rightData.title.name' style='width:250px;margin-right: 10px'/>
						<el-checkbox v-model='rightData.title.hidden'>隐藏</el-checkbox>
					</el-form-item>
					<el-form-item label='模块样式' v-if='rightData.tagName == "文章列表" || rightData.tagName == "多图文" || rightData.tagName == "服务" || rightData.tagName == "搜索" || rightData.tagName == "名片" '>
						<div class="model">
							<div class="li" @click='styleClick(item)' :class='item==rightData.styleon? "on":""' v-for='(item,index) in rightData.style' :key='index'>
								<img v-if='item=="A"' src="@/assets/articleA.jpg">
								<img v-if='item=="B"' src="@/assets/articleB.jpg">
								<img v-if='item=="C"' src="@/assets/articleC.jpg">
								<img v-if='item=="D"' src="@/assets/articleD.jpg">
								<img v-if='item=="多图文A"' src="@/assets/swiperA.gif">
								<img v-if='item=="多图文B"' src="@/assets/swiperB.jpg">
								<img v-if='item=="多图文C"' src="@/assets/swiperC.jpg">
								<img v-if='item=="服务A"' src="@/assets/service1.jpg">
								<img v-if='item=="服务B"' src="@/assets/service2.jpg">
								<img v-if='item=="服务C"' src="@/assets/service3.jpg">
								<img v-if='item=="名片A"' src="@/assets/service2.jpg">
								<img v-if='item=="名片B"' src="@/assets/service3.jpg">
								<img v-if='item=="搜索A"' src="@/assets/searchA.jpg">
								<img v-if='item=="搜索B"' src="@/assets/searchB.jpg">
								<img v-if='item=="搜索C"' src="@/assets/searchC.jpg">
								<img v-if='item=="搜索D"' src="@/assets/searchD.jpg">
							</div>
						</div>
					</el-form-item>
					<div v-if="rightData.tagName=='自由容器' || rightData.tagName=='多图文' || rightData.tagName=='视频' || rightData.tagName=='名片' || rightData.tagName=='文章列表' || rightData.tagName=='服务' || rightData.tagName=='表单' || rightData.tagName=='魔方导航' || rightData.tagName=='搜索'">
						<el-form-item label='下边距' >
							<el-input v-model='rightData.marginBottom' style='width: 200px'/>
						</el-form-item>
					</div>
					<div>
					</div>
					<div v-if='rightData.tagName=="自由容器"'>
						<el-form-item label='高度'>
							<el-input v-model='rightData.h' style='width: 200px'/>
						</el-form-item>
					</div>
					<div v-if='rightData.tagName=="表单"'>
						<el-form-item label='标题'>
							<el-input size='medium' v-model='rightData.submitButton' style='width:160px;margin-right: 10px'/>
						</el-form-item>
						<el-form-item label='提交跳转'>
							<el-input size='medium' v-model='rightData.url' disabled style='width:250px;margin-right: 10px'/>
							<el-button size='medium'  @click='setUrl(rightData)'>设置链接</el-button>
						</el-form-item>
						<el-form-item label='表单列表'>
							<el-button size='mini' @click='addForms'>添加表单</el-button>
							<el-button size='mini' @click='manageForms'>管理表单</el-button>
						</el-form-item>
						<el-table :data='ajaxData.formsList'>
							<el-table-column label='表单名称'>
								<template slot-scope='scope'>
									<el-radio v-model='rightData.formid' :label='scope.row.id'>{{scope.row.name}}</el-radio>
								</template>
							</el-table-column>
							<el-table-column label='操作'>
								<template slot-scope='scope'>
									<ul class="flextools" >
										<li title='查看用户提交数据'><router-link :to='{path:"/form/formContent",query:{id:scope.row.id}}'><svg-icon icon-class='search'/></router-link></li>
										<li title='编辑' @click='reNameForm(scope.row)'><svg-icon icon-class='edit1'/></li>
										<li title="删除表单" @click='delForm(scope.row)'><svg-icon icon-class='close'/></li>
									</ul>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div v-if='rightData.tagName=="视频"' class="video">
						<el-form-item label='添加视频'>
							<el-radio v-model='rightData.srcfrom' label='使用腾讯视频'>使用腾讯视频</el-radio>
							<el-radio v-model='rightData.srcfrom' label='上传视频'>上传视频</el-radio>
						</el-form-item>
						<el-form-item v-if='rightData.srcfrom=="使用腾讯视频"' label='视频地址'>
							<el-input v-model='rightData.srctx' @blur='getTxurl(rightData.srctx)' placeholder='例如：https://v.qq.com/x/page/w03490cq9ha.html'/>
						</el-form-item>
						<el-form-item v-if='rightData.srcfrom=="上传视频"' label='上传视频'>
							<!-- <input type="file"> -->
							<span style="color: #aaa">暂不支持上传视频，您可先上传到腾讯视频</span>
						</el-form-item>
						<el-form-item label='封面图'>
							<div style="display: flex;">
								<div v-if="rightData.indexImg" class="videoImg"><img :src="rightData.indexImg" alt=""></div>
								<el-button size='small' style='height: 32px;'  @click='selectVideoImg(rightData)'>选择封面</el-button>
							</div>
						</el-form-item>
						<el-form-item label='描述'>
							<el-input type='textarea' v-model='rightData.desc'/>
						</el-form-item>
					</div>
					<div class="newsStyle" v-if='rightData.tagName=="多图文"'>
						<el-form-item label='轮播图高度'>
							<el-input v-model='rightData.swiper_height' placeholder='默认150px'/>
						</el-form-item>
						<el-form-item label='图片设置'>
							<span style="font-size: 12px;color: #aaa">(最佳尺寸：750*300px)</span>
						</el-form-item>
						<div class="imgbox">
							<div class="img" :class='imgon==index?"imgon":""'   @click='selectImg(item,index)' v-for='(item,index) in rightData.imglist' :key='index' >
								<img :src="item.src" alt="">
								<div class="delSelectImg" @click='delSelectImg(item,index)'><svg-icon class='icon' icon-class='close'/></div>
								<div class="bottom">
									<div class="check" ><svg-icon class='icon' icon-class='check'/></div>
								</div>
							</div>
							<div class="imgAdd" @click='addNewImg'>
								<svg-icon icon-class='add'/>
							</div>
						</div>
						<el-form-item label='链接' v-if='rightData.imglist[imgon]'>
							<el-input size='medium' v-model='rightData.imglist[imgon].url' disabled style='width:250px;margin-right: 10px'/>
							<el-button size='medium' @click='setUrl(rightData.imglist[imgon])'>设置链接</el-button>
						</el-form-item>
						<el-form-item label='描述' v-if='rightData.imglist[imgon]'>
							<el-input size='medium' v-model='rightData.imglist[imgon].label' style='width:250px;margin-right: 10px'/>
						</el-form-item>
					</div>
					<!-- 文章特有样式 -->
					<div class="articleStyle" v-if='rightData.tagName=="文章列表"'>
						<el-form-item label='选择文章'>
							<el-radio v-model='rightData.artcleType' label='直接添加'>直接添加</el-radio>
							<el-radio  v-model='rightData.artcleType' label='筛选分类'>筛选分类</el-radio>
						</el-form-item>
						<div v-if='rightData.artcleType=="直接添加"'>
							<el-transfer filterable filter-placeholder="搜索文章" v-model="rightData.articleValue" :data="ajaxData.articlelist">
								<div slot="left-footer" class="tr-footer">
									<el-button size="small" @click='addArticle'>添加</el-button>
								</div>

							</el-transfer>
						</div>
						<div v-if='rightData.artcleType=="筛选分类"' class="filter">
							<div class="checkbox" v-for='(art,i) in classify'>
								<el-checkbox v-model='art.checked'>{{art.title}}</el-checkbox>
							</div>
						</div>
					</div>
					<div class="card" v-if='rightData.tagName =="名片"'>
						<el-transfer filterable filter-placeholder="搜索名片" v-model="rightData.cardValue" :data="ajaxData.cardlist">
							<div slot="left-footer" class="tr-footer">
								<el-button size="small" @click='addCard'>添加</el-button>
							</div>
						</el-transfer>
					</div>
					<div class="coupon" v-if='rightData.tagName =="优惠券"'>
						<el-form-item label='模块样式' >
							<div class="model">
								<div class="li" @click='styleClick(item)' :class='item==rightData.styleon? "on":""' v-for='(item,index) in rightData.style' :key='index'>
									<img v-if='item=="优惠券A"' src="@/assets/goodsA.jpg">
									<img v-if='item=="优惠券B"' src="@/assets/goodsB.jpg">
								</div>
							</div>
						</el-form-item>

						<el-transfer filterable filter-placeholder="搜索优惠券" target-order="push" :props='{key:"id",label:"title"}' v-model="rightData.value" :data="ajaxData.couponList">
							<div slot="left-footer" class="tr-footer">
								<el-button size="small" @click='addCoupon'>添加</el-button>
							</div>
						</el-transfer>
					</div>

					<div class="navs" v-if='rightData.tagName=="魔方导航"'>
						<el-form-item label='模块样式'>
							<div class="navsstyle">
								<div class="li" @click='rightData.navstyleOn=a' v-for='(a,b) in rightData.navstyle' :class='a==rightData.navstyleOn?"on":""'>
									<img v-if='a == "styleA"' src="@/assets/nav1.jpg">
									<img v-if='a == "styleB"' src="@/assets/nav2.jpg">
									<img v-if='a == "styleC"' src="@/assets/nav3.jpg">
									<img v-if='a == "styleD"' src="@/assets/nav4.jpg">
								</div>
							</div>
						</el-form-item>
						<el-form-item label='列数' v-if='rightData.navstyleOn=="styleA"'>
							<div class="radiobox">
								<el-radio v-model='rightData.col' label='4'>4列</el-radio>
								<el-radio v-model='rightData.col' label='5'>5列</el-radio>
							</div>
						</el-form-item>
					</div>
					<!-- 商品特有样式 -->
					<div class="articleStyle" v-if='rightData.tagName=="商品"'>
						<el-form-item label='模块样式' >
							<div class="model">
								<div class="li" @click='styleClick(item)' :class='item==rightData.styleon? "on":""' v-for='(item,index) in rightData.style' :key='index'>
									<img v-if='item=="商品A"' src="@/assets/goodsA.jpg">
									<img v-if='item=="商品B"' src="@/assets/goodsB.jpg">
									<img v-if='item=="商品C"' src="@/assets/goodsC.jpg">
									<img v-if='item=="商品D"' src="@/assets/goodsB.jpg">
								</div>
							</div>
						</el-form-item>
						<el-form-item label='卡片背景' >
							<el-color-picker show-alpha v-model='rightData.cardBg'/>
						</el-form-item>
						<el-transfer filterable filter-placeholder="搜索商品" target-order="push" v-model="rightData.value" :data="ajaxData.goodsList">
							<div slot="left-footer" class="tr-footer">
								<el-button size="small" @click='addSever'>添加</el-button>
							</div>
						</el-transfer>
					</div>
					<!-- {{rightData}} -->
					<!-- 商品特有样式 -->
					<div class="articleStyle" v-if='rightData.tagName=="视频课程"'>
						<el-form-item label='模块样式' >
							<div class="model">
								<div class="li" @click='styleClick(item)' :class='item==rightData.styleon? "on":""' v-for='(item,index) in rightData.style' :key='index'>
									<img v-if='item=="课程A"' src="@/assets/goodsA.jpg">
									<img v-if='item=="课程B"' src="@/assets/goodsB.jpg">
									<img v-if='item=="课程C"' src="@/assets/goodsC.jpg">
									<img v-if='item=="课程D"' src="@/assets/goodsB.jpg">
								</div>
							</div>
						</el-form-item>
						<el-form-item label='卡片背景' >
							<el-color-picker show-alpha v-model='rightData.cardBg'/>
						</el-form-item>
						<el-transfer filterable filter-placeholder="搜索课程" v-model="rightData.value" :data="ajaxData.video_list" :props="{key: 'id',label: 'title'}">
							<div slot="left-footer" class="tr-footer">
								<el-button size="small" @click='addSever'>添加</el-button>
							</div>
						</el-transfer>
					</div>
					<!-- 服务特有样式 -->
					<div class="articleStyle" v-if='rightData.tagName=="服务"'>
						<el-transfer filterable filter-placeholder="搜索服务" v-model="rightData.severValue" :data="ajaxData.severlist">
							<div slot="left-footer" class="tr-footer">
								<el-button size="small" @click='addSever'>添加</el-button>
							</div>
						</el-transfer>
					</div>
					<div class="articleStyle" v-if='rightData.tagName=="商品拼团"'>
						<el-transfer filterable filter-placeholder="搜索" v-model="rightData.value" :data="ajaxData.groupbyList"  :props="{key: 'id',label: 'title'}">
							<div slot="left-footer" class="tr-footer">
								<el-button size="small" @click='addSever'>添加</el-button>
							</div>
						</el-transfer>
					</div>
					<div class="articleStyle" v-if='rightData.tagName=="搜索"'>
						<el-form-item label='搜索提示'>
							<el-input v-model='rightData.placeholder' style='width: 250px;' placeholder='搜索提示'/>
						</el-form-item>
						<el-form-item label='搜索内容'>
							<el-radio v-model='rightData.include' label='服务和文章和商品'></el-radio>
							<el-radio v-model='rightData.include' label='服务'></el-radio>
							<el-radio v-model='rightData.include' label='文章'></el-radio>
              <el-radio v-model='rightData.include' label='商品'></el-radio>
						</el-form-item>
					</div>
					<div class="tabbar" v-if='rightData.tagName == "导航"'>
						<el-form-item label=''>
							<div class="btns">
								<el-button type='small' @click='editTabbar("add")'>添加导航</el-button>
							</div>
						</el-form-item>
						<div class="table">
							<el-table :data='rightData.list' class='sorts' :row-key='getIcoTableKey' >
								<el-table-column border prop='title' label='导航文字'></el-table-column>
								<el-table-column label='链接'>
									<template slot-scope="scope">
										<span>{{scope.row.url | parseUrl}}</span>
									</template>
								</el-table-column>
								<el-table-column label='默认图标'>
									<template slot-scope="scope">
										<div class="tabbarico" @click='selectIco(scope.row.icon)'>
											<svg-icon class='icos' v-if='scope.row.icon.type=="图标"' :icon-class='scope.row.icon.src'/>
											<img class='icos' v-else :src='scope.row.icon.src'/>
										</div>
									</template>
								</el-table-column>
								<el-table-column label='选中图标'>
									<template slot-scope="scope">
										<div class="tabbarico" :style="`color:${appConfig.style}`" @click='selectIco(scope.row.icon_on)'>
											<svg-icon class='icos'  v-if='scope.row.icon_on.type=="图标"'  :icon-class='scope.row.icon_on.src'/>
											<img class='icos' v-else :src='scope.row.icon_on.src'/>
										</div>
									</template>
								</el-table-column>
								<el-table-column label='操作'>
									<template slot-scope="scope">
										<div class="do">
											<div class="doli" @click='editTabbar(scope.row,scope.$index)'>
												<svg-icon icon-class='edit1'/>
											</div>
											<div class="doli" @click='delTabbar(scope.row,scope.$index)'>
												<svg-icon icon-class='del'/>
											</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-form-item label='默认颜色'>
							<el-color-picker v-model="rightData.default" size="small"></el-color-picker>
						</el-form-item>
						<el-form-item label='选中颜色'>
							<el-radio v-model='rightData.useStyle' :label='true'>使用全局颜色</el-radio>
							<el-radio v-model='rightData.useStyle' :label='false'>自定义颜色</el-radio>
							<br/>
							<el-color-picker v-if='!rightData.useStyle' v-model="rightData.hover" size="small"></el-color-picker>
						</el-form-item>
						<el-form-item label='背景颜色'>
							<el-color-picker v-model="rightData.bg" size="small"></el-color-picker>
						</el-form-item>
					</div>
					<div class="articleClass" v-if='rightData.tagName=="文章分类"'>
						<el-button size='small' @click='editClassify("article","add")'>添加</el-button>
						<el-table :data='ajaxData.articleClassify'>
							<el-table-column prop='title' label='名称'>
							</el-table-column>
							<el-table-column prop='title' label='编辑'>
								<template slot-scope="scope">
									<ul class="flextools">
										<li @click='editClassify("article",scope.row)'><svg-icon icon-class='edit1'/></li>
										<li @click='delClassify("article",scope.row)'><svg-icon icon-class='close'/></li>
									</ul>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="articleClass" v-if='rightData.tagName=="商品分类"'>
						<el-button size='small' @click='editClassify("goods","add")'>添加</el-button>
						<el-table :data='ajaxData.goodsClassify'>
							<el-table-column prop='title' label='名称'>
							</el-table-column>
							<el-table-column prop='title' label='编辑'>
								<template slot-scope="scope">
									<ul class="flextools">
										<li @click='editClassify("goods",scope.row)'><svg-icon icon-class='edit1'/></li>
										<li @click='delClassify("goods",scope.row)'><svg-icon icon-class='close'/></li>
									</ul>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="articleClass" v-if='rightData.tagName=="服务分类"'>
						<el-button size='small' @click='editClassify("sever","add")'>添加</el-button>
						<el-table :data='ajaxData.severClassify'>
							<el-table-column prop='title' label='名称'>
							</el-table-column>
							<el-table-column prop='title' label='编辑'>
								<template slot-scope="scope">
									<ul class="flextools">
										<li @click='editClassify("sever",scope.row)'><svg-icon icon-class='edit1'/></li>
										<li @click='delClassify("sever",scope.row)'><svg-icon icon-class='close'/></li>
									</ul>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-form>
			</div>
			<div class="propbox" v-if='rightData.navOn==1'>
				<el-form label-width="80px">
					<el-form-item label='查看全部' v-if='rightData.tagName=="文章" || rightData.tagName=="服务" || rightData.tagName=="名片"'>
						<el-radio v-model='rightData.title.more' :label='true'>默认</el-radio>
						<el-radio v-model='rightData.title.more' :label='false'>隐藏</el-radio>
					</el-form-item>
					<el-form-item label='背景色'>
						<el-radio v-model='rightData.setbg' :label='false'>默认</el-radio>
						<el-radio v-model='rightData.setbg' :label='true'>自定义</el-radio>
					</el-form-item>
					<el-form-item label='设置背景' v-if='rightData.setbg'>
						<el-color-picker v-model="rightData.bgcolor" show-alpha></el-color-picker>
					</el-form-item>

				</el-form>
			</div>
			<div class="propbox" v-if='rightData.navOn==2'>
				<div class="formContent" v-if='rightData.tagName=="表单"'>
					<el-form label-width="80px">
						<el-form-item label='添加列'>
							<el-button size='mini' @click='addItem("input")'>
								<svg-icon class='btnico' icon-class='input'/>
								<span>单行文本</span>
							</el-button>
							<el-button size='mini' @click='addItem("textarea")'>
								<svg-icon class='btnico'  icon-class='textarea'/>
								<span>多行文本</span>
							</el-button>
							<el-button size='mini' @click='addItem("radio")'>
								<svg-icon class='btnico'  icon-class='radio'/>
								<span>单选按钮</span>
							</el-button>
							<el-button size='mini' @click='addItem("checkbox")'>
								<svg-icon class='btnico'  icon-class='checkbox'/>
								<span>多选按钮</span>
							</el-button>
							<el-button size='mini' @click='addItem("upload")'>
								<svg-icon class='btnico'  icon-class='upload'/>
								<span>上传图片</span>
							</el-button>
							<el-button size='mini' @click='addItem("datebox")'>
								<svg-icon class='btnico'  icon-class='datebox'/>
								<span>日期时间</span>
							</el-button>
						</el-form-item>
						<el-table v-for='(forms,formi) in ajaxData.formsList' :key='formi' :data='forms.configuration' v-if='rightData.formid==forms.id' class='sorts' row-key='label'>
							<el-table-column label='项名称' prop='label'>
							</el-table-column>
							<el-table-column label='必填'>
								<template  slot-scope="scope">
									<el-switch v-model="scope.row.required" ></el-switch>
								</template>
							</el-table-column>
							<el-table-column label='操作' >
								<template  slot-scope="scope">
									<ul class="flextools">
										<li @click='editItem(scope.row,scope.$index)'>
											<svg-icon icon-class='edit1' />
										</li>
										<li @click='delitem(scope.$index)'>
											<svg-icon icon-class='del' />
										</li>

									</ul>
								</template>
							</el-table-column>
						</el-table>
					</el-form>
				</div>
				<div v-if="rightData.tagName=='魔方导航'">
					<el-form label-width="80px">
						<el-form-item label='导航项'>
							<el-button size='mini' @click='requirePage'>导入页面配置</el-button>
							<el-button size='mini' @click='addPage'>添加导航</el-button>
						</el-form-item>
						<el-table :data='rightData.list' class='sorts' :row-key="(row)=>{return row.id}">
							<el-table-column label='项名称' prop='label'>
							</el-table-column>

							<el-table-column label='图标' >
								<template  slot-scope="scope">
									<div class="tabbarico" @click='selectIco(scope.row.icon)'>
										<svg-icon class='icos' v-if='scope.row.icon.type=="图标"' :icon-class='scope.row.icon.src'/>
										<img class='icos' v-else :src='scope.row.icon.src'/>
									</div>
								</template>
							</el-table-column>
							<el-table-column label='图标颜色'>
								<template  slot-scope="scope">
									<el-color-picker size='small' v-if='scope.row.icon.type=="图标"' v-model="scope.row.icon.color" show-alpha></el-color-picker>
									<el-tooltip v-else class="item" effect="dark" content="仅对图标有效" placement="top">
										<svg-icon style='width: 20px;height: 20px;color:#999' icon-class='question'/>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column label='背景颜色'>
								<template  slot-scope="scope">
									<el-color-picker size='small'  v-model="scope.row.bgcolor" show-alpha></el-color-picker>
								</template>
							</el-table-column>


							<el-table-column label='操作' >
								<template  slot-scope="scope">
									<div style="display: flex">
										<div class="del" title='编辑更多属性' style="cursor: pointer;margin-right: 10px;" @click='editNav(scope.row)'>
											<svg-icon icon-class='edit1' />
										</div>
										<div class="del" title='删除' style="cursor: pointer" @click='delNav(scope.$index)'>
											<svg-icon icon-class='del' />
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</el-form>
				</div>
			</div>
			<div class="propbox goodsClassifyRight" v-if='rightData.page=="goodsClassify"'>
				<el-form>
					<el-form-item label='模块样式'>
						<div class="navsstyleclass">
							<div @click='setData(rightData,"styleon","A")' class="li" :class='rightData.styleon=="A"? "on" :""' >
								<img  src="@/assets/goodsclassifyA.jpg" >
							</div>
							<div @click='setData(rightData,"styleon","B")' class="li" :class='rightData.styleon=="B"? "on" :""'  >
								<img  src="@/assets/goodsclassifyB.jpg" >
							</div>
							<div @click='setData(rightData,"styleon","C")' class="li" :class='rightData.styleon=="C"? "on" :""'  >
								<img  src="@/assets/goodsclassifyC.jpg" >
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="propbox goodsClassifyRight" v-if='rightData.page=="my"'>
				<el-form label-width='100px'>
					<el-form-item label='个人中心背景'>
						<div class="img" @click='changemybg' style="width: 260px;height: 104px;overflow: hidden;border: 1px dashed #aaa;cursor: pointer;">
							<img style="width: 100%;" :src="rightData.mybg || 'http://diy.eingdong.com/system_img/mybg.png'" >
						</div>
						<el-button size='small' @click='rightData.mybg=""'>恢复默认</el-button>
						<span style="margin-left: 10px;color: #aaa">建议尺寸750px*300px</span>
					</el-form-item>
				</el-form>
			</div>

		</div>
		<div class="dhbox">
			<el-dialog title="提示" append-to-body :visible.sync="tabbarSet" width="30%">
				<div>
					<el-form>
						<el-form-item label='跳转页面'>
							<el-select v-model="tabbarForm.url" @change='addtabbar' placeholder="请选择">
								<el-option v-for="(item,index) in appConfig.appPage" :key="index" :label="item.title" :value="item.url">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="tabbarSet = false">取 消</el-button>
					<el-button type="primary" @click="saveTabbar">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'
	import Sortable  from 'sortablejs'
	import {addForms,getForms,get_classify_list,get_classify_article_list,codeTovideo,reNameForm,delForm,add_classify,editor_classify,delArticlerClassify,add_sever_classify,delSeverClassify,editor_sever_classify,addGoodsClassify,editGoodsClassify,delGoodsClassify} from "@/api/api"
	var p,lb,rb,pb,dialogs,_this,rowkeyi=0;
	export default{
		components:{
			draggable,
			Sortable
		},
		props:{
			hideright:{
				type:Boolean
			},
			rightData:{
				type:Object
			},
			phoneData:{
				type:Object
			},
			appConfig:{
				type:Object
			},
			ajaxData:{
				type:Object
			}
		},
		filters:{
			parseUrl(val){
				if(!val){
					return false
				}
				var url = val.split('://');
				if(url[0] == 'slef'){
					if(url[1]=='index') return "首页";
					if(url[1]=='my') return "个人中心";
				}
				return val
			}
		},
		data(){
			return {
				inputVisible: false,
				inputValue: '',
				tabbarSet:false,
				selectNavColor:'#fff',
				tabbarForm:{
					url:{}
				},
				tabbarAction:'add',
				// font
				fontstyle:[
				{target:'b',check:'blod',nocheck:'normal',icon:'b'},
				{target:'i',check:'italic',nocheck:'normal',icon:'i'},
				{target:'align',check:'left',nocheck:'',icon:'align-left'},
				{target:'align',check:'center',nocheck:'',icon:'align-middle'},
				{target:'align',check:'right',nocheck:'',icon:'align-right'},
				],
				classify:[],
				imgon:-1,
				filterMethod(query, item) {
					return item.label.indexOf(query) > -1;
				},
				forms:{
					name:'',
					style:0,
					artcleType:'直接添加'
				}
			}
		},
		watch:{
			'rightData.imglist':{
				handler(val){
					if(this.rightData.tagName != "多图文"){
						return false
					}
					p.ajaxData.imgData.forEach((item,i)=>{
						var bool;
						val.find((value)=>{
							if(value.id == item.id){
								this.$set(p.ajaxData.imgData[i],'check',true)
							}
						})
					})
				}
			},
			'rightData':{
				handler(val){
          console.log(val)
					if(val){
						if(val.tagName=="魔方导航" && val.navOn == "2" || val.tagName=="导航" ){
							setTimeout(()=>{
								console.log("初始化拖拽排序")
								this.rowDrop()
							},50)
						}
						else if(val.tagName=="表单" && val.navOn == "2"){
							setTimeout(()=>{
								console.log("初始化拖拽排序")
								this.rowFormDrop()
							},50)
						}
					}
				},
				deep:true
			},
			classify:{
				handler(val){
					console.log(val)
					var clist = "";
					val.forEach((v,i)=>{
						if(v.checked) clist+=v.id+','
					})
					console.log(this.rightData)
					if(clist){
						get_classify_article_list({classify_id:clist},this,res=>{
							var reslist = [];
							res.data.list.forEach((r)=>{
								reslist.push(r.id)
							})
							this.$set(p.rightData,'articleValue',reslist)
						})
					}
					else{
						this.$set(p.rightData,'articleValue',[])
					}
				},
				deep:true
			}
		},
		methods:{
			changemybg(){
				this.$store.commit("select_img",{
					mult:1,
					success:res=>{
						if(res[0]){
							this.$set(p.rightData,"mybg",res[0])
						}
					}
				})
			},
			setData(key,item,value){
				this.$set(key,item,value)
			},
			delClassify(where,item){
				pb = this.$parent.$refs.phoneBlock;
				this.$confirm("确认删除此分类？",'提示',{
					type:"warning"
				}).then(()=>{
					switch(where){
						case "article":
						delArticlerClassify({id:item.id},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							pb.getarticleClassify()
						})
						break;
						case "sever":
						delSeverClassify({id:item.id},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							pb.getSeverClassify()
						})
						break;
						case "goods":
						delGoodsClassify({id:item.id},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							pb.getGoodsClassify()
						})
						break;
					}
				}).catch(()=>{})
			},
			editClassify(where,action){
				pb = this.$parent.$refs.phoneBlock;
				this.$prompt('分类名称', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputValue:action=="add"? "":action.title
				}).then(({ value }) => {
					switch(where){
						case "article":
						if(action =="add"){
							add_classify({title:value},this,res=>{
								this.$message({
									type:'success',
									message:res.data.msg
								})
								pb.getarticleClassify()

							})
						}else{
							editor_classify({classify_id:action.id,title:value},this,res=>{
								this.$message({
									type:'success',
									message:res.data.msg
								})
								pb.getarticleClassify()
							})
						}
						break;
						case "sever":
						if(action =="add"){
							add_sever_classify({title:value},this,res=>{
								this.$message({
									type:'success',
									message:res.data.msg
								})
								pb.getSeverClassify()

							})
						}else{
							editor_sever_classify({classify_id:action.id,title:value},this,res=>{
								this.$message({
									type:'success',
									message:res.data.msg
								})
								pb.getSeverClassify()
							})
						}
						break;
						case "goods":
						if(action =="add"){
							addGoodsClassify({title:value},this,res=>{
								this.$message({
									type:'success',
									message:res.data.msg
								})
								pb.getGoodsClassify()

							})
						}else{
							editGoodsClassify({classify_id:action.id,title:value},this,res=>{
								this.$message({
									type:'success',
									message:res.data.msg
								})
								pb.getGoodsClassify()
							})
						}
						break;
					}
				}).catch(() => { });
			},
			reNameForm(item){
				this.$prompt('请输入表单名称', '修改表单', {
					inputValue:item.name
				}).then(({ value }) => {
					reNameForm({form_id:item.id,name:value},this,res=>{
						this.$message({
							type:"success",
							message:res.data.msg
						})
						this.getForms()
					})
				}).catch(() => {
				});
			},
			delForm(item){
				this.$confirm('确认删除此表单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delForm({id:item.id},this,res=>{
						this.$message({
							type: 'success',
							message: res.data.msg
						});
						this.getForms()
					})
				}).catch(() => {});
			},
			getTxurl(url){
				codeTovideo(url,this,res=>{
					this.$set(p.rightData,"srctxParse",res)
				})
			},
			addArticle(){
				pb = this.$parent.$refs.phoneBlock;
				dialogs.editArticle('add',res=>{
					this.get_classify_list();
					pb.getArticleList();
				})
			},
			addSever(){
				pb = this.$parent.$refs.phoneBlock;
				dialogs.editSever('add',res=>{
					pb.getSeverList();
				})
			},
			addCard(){
				pb = this.$parent.$refs.phoneBlock;
				dialogs.editCard('add',res=>{
					pb.getCardList();
				})
			},
			addCoupon(){
				pb = this.$parent.$refs.phoneBlock;
        console.log(this.$parent.$refs.phoneBlock)
        console.log(pb)
				dialogs.editCoupon('add',res=>{
					pb.getTicketList();
				})
			},
			editArticle(e){
			},
			addForms(){
				this.$prompt('请输入唯一的表单名称', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({ value }) => {
					addForms({name:value},this,res=>{
						this.$message({
							type:'success',
							message:res.data.msg
						})
						this.getForms()
					})
				}).catch(() => {
				});
			},
			getForms(){
				getForms(this,res=>{
					res.data.list.forEach((val,index)=>{
						val.configuration = val.configuration? JSON.parse(val.configuration):[];
					})
					console.log(res.data.list)
					this.$set(p.ajaxData,'formsList',res.data.list)
				})
			},
			delTag(father,i){
				father.splice(i,1)
			},
			manageForms(){

			},
			setUrl(slef){
				dialogs.selectUrlSuccess=function(){
					console.log("dialogs",dialogs)
					var url = dialogs.selectLast.indexOf('://') == -1 ? dialogs.selectFirst+dialogs.selectLast : dialogs.selectLast;
					if(url == "map://"){
						url += dialogs.inputAddr +','+dialogs.lat+','+dialogs.lng
					}
					console.log(url)
					_this.$set(slef,"url",url)
					_this.$set(slef,'urldetail',{selectLast:dialogs.selectLast,selectFirst:dialogs.selectFirst,urlTitle:'',lat:dialogs.lat,lng:dialogs.lng,inputAddr:dialogs.inputAddr})
					console.log(slef)
					dialogs.selectLast = "";
					dialogs.selectFirst = "";
					dialogs.showSelectUrl=false;
				}
				console.log('pages',p.appConfig.appPage)
				dialogs.selectUrl(p.appConfig.appPage,slef)
			},
			addNewImg(){

				this.$store.commit("select_img",{
					mult:true,
					success:res=>{
						res.forEach((val,index)=>{
							res[index] = {
								src:val,
								url:'',
								label:val,
								check:false
							}
						})
						console.log(res)
					_this.$set(p.rightData,'imglist',[...p.rightData.imglist,...res])
					}
				})
			},
			selectFreeImg(){
				this.$store.commit("select_img",{
					mult:1,
					success:res=>{
						if(res[0]){
							_this.$set(_this.rightData,'src',res[0])
						}
					}
				})
			},
			selectIco(row){
				console.log(dialogs)
				dialogs.editIco(row);
				dialogs.editIcoSuccess=function(){
					var select = {};
					row.type = dialogs.usericoNav;
					if(dialogs.usericoNav == "图标"){
						dialogs.usericos.forEach((val,index)=>{
							if (val.check){
								select = val;
							}
						})
						row.src = select.icon;
					}
					if(dialogs.usericoNav == "图片"){
						row.src = dialogs.usericoImg;
						dialogs.usericoImg = "";
					}
					dialogs.showSelectIco=false;
					dialogs.editIcoSuccess=function(){};
				}
			},
			selectVideoImg(item){
				this.$store.commit("select_img",{
					mult:1,
					success:res=>{
						if(res[0]){
							_this.$set(item,'indexImg',res[0])
						}
					}
				})
			},
			requirePage(){
				p.appConfig.appPage.forEach((item,index)=>{
					this.rightData.list.push({tagName:'图标',id:Date.parse(new Date())+index,nav:['导航项'],navOn:0,label:item.title,fontsize:12,color:'rgba(0,0,0,1)',b:'normal',minTitle:'副标题',minTitleColor:'rgba(80,80,80,1)',minTitleB:'normal',minTitleFontsize:'12',hidden:false,icon:{type:'图片',src:'http://img.alicdn.com/tps/TB1ld1GNFXXXXXLapXXXXXXXXXX-200-200.png',color:''},bgcolor:'rgb(240,240,240)',url:item.url})
				})
			},
			addPage(){

				this.rightData.list.push({tagName:'图标',id:Date.parse(new Date()),nav:['导航项'],navOn:0,label:'图标1',fontsize:12,color:'rgba(0,0,0,1)',b:'normal',minTitle:'副标题',minTitleColor:'rgba(80,80,80,1)',minTitleB:'normal',minTitleFontsize:'12',hidden:false,icon:{type:'图片',src:'http://img.alicdn.com/tps/TB1ld1GNFXXXXXLapXXXXXXXXXX-200-200.png',color:''},bgcolor:'rgb(240,240,240)',url:'slef://index'})
			},
			addItem(type){
				console.log('add')
				var i = p.ajaxData.formsList.findIndex((val,index)=>{
					return val.id == this.rightData.formid
				})
				switch (type){
					case "input":
					p.ajaxData.formsList[i].configuration.push({tagName:'input',nav:['单行文本'],navOn:0,showLabel:true,label:'单行文本',placeholder:'请输入文本内容',required:true})
					break;
					case "textarea":
					p.ajaxData.formsList[i].configuration.push({tagName:'textarea',nav:['多行文本'],navOn:0,showLabel:true,label:'多行文本',placeholder:'请输入多行文本',required:false})
					break;
					case "radio":
					p.ajaxData.formsList[i].configuration.push({tagName:'radio',nav:['单选按钮'],navOn:0,showLabel:true,label:'性别',check:'男',section:[{value:'男'},{value:'女'}],required:true})
					break;
					case "checkbox":
					p.ajaxData.formsList[i].configuration.push({tagName:'checkbox',nav:['多选按钮'],navOn:0,showLabel:true,label:'多选框',section:[{value:'选项一',checked:true},{value:'选项二'}],required:false})
					break;
					case "upload":
					p.ajaxData.formsList[i].configuration.push({tagName:'upload',nav:['上传图片'],navOn:0,showLabel:true,label:'图片上传',placeholder:'请上传图片',required:false})
					break;
					case "datebox":
					p.ajaxData.formsList[i].configuration.push({tagName:'datebox',nav:['日期时间'],navOn:0,showLabel:true,label:'选择日期',placeholder:'请选择日期',required:false})
					break;
				}
			},
			editItem(item,index){
				pb = this.$parent.$refs.phoneBlock;
				console.log('123',pb)
				this.$set(pb,'childon',[p.phoneData.selectIndex,index])
				this.$set(p,'rightData',item)
			},
			delitem(index){
				var formindex = p.ajaxData.formsList.findIndex((val)=>{
					return val.id == p.rightData.formid
				})
				console.log(formindex)
				if(p.ajaxData.formsList[formindex].configuration.length<=1){
					this.$message.error('表单选项不能低于1')
					return false;
				}
				this.$confirm('确认删除此选项?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					p.ajaxData.formsList[formindex].configuration.splice(index,1)
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
				});
			},
			editNav(item){
				console.log(item)
				this.$set(p,'rightData',item)
			},
			delNav(index){
				if(p.rightData.list.length<=1){
					this.$message.error('导航项不能低于1个')
					return false;
				}
				this.$confirm('确认删除此选项?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					p.rightData.list.splice(index,1)
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
				});
			},
			showInput() {
				this.inputVisible = true;
				// this.$nextTick(_ => {
				// 	this.$refs.saveTagInput.$refs.input.focus();
				// });
			},
			getIcoTableKey(row){
				console.log(row)
				return row.title
			},
			confirmTag() {
				let inputValue = this.inputValue;
				console.log(this.rightData)
				if (inputValue) {
					this.rightData.section.push({
						value:inputValue
					})
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			linkClick(){
				p.rightData.link = !p.rightData.link
			},
			addtabbar(){
				console.log('123')
			},
			editTabbar(action,index){
				console.log(action)
				if(action=='add'){
					this.tabbarAction ='add';
					this.tabbarForm={url:''}
				}
				else{
					this.tabbarAction=action;
					this.tabbarForm.url = action.url;
					this.tabbarIndex = index;
				}
				this.tabbarSet=true;
			},
			delTabbar(item,index){
				if(this.rightData.list.length <=2){
					this.$message.error('导航项不能低于2个')
					return false
				}
				this.$confirm('确认删除导航"'+item.title+'"?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.rightData.list.splice(index,1);
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
				});
			},
			saveTabbar(){
				if(this.rightData.list.length >=5){
					this.$message.error('导航不能大于5个')
					return false
				}
				var a = p.appConfig.appPage.find((val,index)=>{
					if(this.tabbarForm.url == val.url)
						return val
				})
				if(a){
					if( this.tabbarAction=='add'){
						this.rightData.list.push(
							{title:a.title,type:a.type,icon:{type:'图标',src:'g_default'},icon_on:{type:'图标',src:'g_default_on'},url:a.url}
							)
					}
					else{
						console.log('index',this.tabbarIndex)
						this.$set(this.rightData.list,this.tabbarIndex,{title:a.title,type:a.type,icon:{type:'图标',src:'g_default'},icon_on:{type:'图标',src:'g_default_on'},url:a.url})
					}
				}
				this.tabbarSet=false
			},
			styleClick(item){
				this.$set(p.rightData,"styleon",item)
				console.log(p.rightData)
				if(item=="多图文B" || item=="多图文c"){
					this.$set(p.rightData,'h','auto')
				}
				if(item=="多图文A" ){
					this.$set(p.rightData,'h','150')
				}
			},
			selectImg(item,index){
				this.imgon = this.imgon == index? -1 : index;
				var hasindex = p.rightData.imglist.findIndex((value,i)=>{
					return value.id == item.id
				})
			},
			delSelectImg(item,index){
				this.rightData.imglist.splice(index,1)
			},
			rowKey(row,i){
				return row.label
			},
			rowDrop() {
				const tbody = document.querySelector('.sorts tbody')
				_this = this;
				Sortable.create(tbody, {
					onEnd({ newIndex, oldIndex }) {
						const currRow = p.rightData.list.splice(oldIndex, 1)[0]
						p.rightData.list.splice(newIndex, 0, currRow)
					}
				})
			},
			rowFormDrop() {
				const tbody = document.querySelector('.sorts tbody')
				_this = this;
				Sortable.create(tbody, {
					onEnd({ newIndex, oldIndex }) {
						var formindex = p.ajaxData.formsList.findIndex((val)=>{
							return val.id == p.rightData.formid
						})
						const currRow = p.ajaxData.formsList[formindex].configuration.splice(oldIndex, 1)[0]
						p.ajaxData.formsList[formindex].configuration.splice(newIndex, 0, currRow)
					}
				})
			},
			get_classify_list(){
				get_classify_list(this,res=>{
					res.data.list.forEach((val,index)=>{
						val.checked = false
					})
					this.classify = res.data.list
				})
			}
		},
		mounted(){
			p = this.$parent;
			_this = this;
			this.getForms();
			this.get_classify_list();
			dialogs = this.$root.$children[0].$refs.dialogbox;
      // console.log(this.ajaxData.goodsList)
      console.log(this.rightData.value)
      setTimeout(()=>{
        // var goodsList = this.ajaxData.goodsList
        // console.log(goodsList)
        // this.ajaxData.goodsList = goodsList.reverse()
      },2000)

       // this.ajaxData.goodsList = goodsList.reverse()
      // this.ajaxData.goodsList = this.ajaxData.goodsList.reverse()
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/rightBlock/rightBlock.vue